<script lang="ts">
  import { Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Input, Row } from "sveltestrap"
  import { PIL, USDC, WETH } from "../stores/constants"
  import type { Denominator } from "../utils/utils"

  export let selectedToken = PIL;
  export let value = 0;

  const selectToken = (token: Denominator) => {
    return () => {
      selectedToken = token;
    }
  }

  const oninput = (e: Event) => {
    if (e !== undefined) {
      const v = Number.parseFloat((e.target as HTMLInputElement).value);
      if (isNaN(v)) {
        value = 0;
      } else {
        value = v;
      }
    }
  };
</script>

<div class="token-input-box">
  <Row>
    <Col class="col-auto">
      <Dropdown>
        <DropdownToggle caret class="token-input-label">
          <img class="icon-small" src="/icons/pil-fill.svg" alt="placeholder"/>
          &nbsp;&nbsp;{selectedToken.symbol}&nbsp;
          <i class="ri-arrow-down-s-line icon-small"></i>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem on:click={selectToken(PIL)}>
            <Row class="gx-1">
              <Col class="col-auto">
                <img class="icon-small" src="/icons/pil-fill.svg" alt="placeholder"/>
              </Col>
              <Col class="align-self-start">
                &nbsp;&nbsp;{PIL.symbol}
              </Col>
              <Col class="col-auto">
                <img class="icon-small" src="/icons/check.svg" alt="placeholder"/>
              </Col>
            </Row>
          </DropdownItem>
          <DropdownItem on:click={selectToken(WETH)}>
            <Row class="gx-1">
              <Col class="col-auto">
                <img class="icon-small" src="/icons/currency-eth.svg" alt="placeholder"/>
              </Col>
              <Col class="align-self-start">
                &nbsp;&nbsp;{WETH.symbol}
              </Col>
            </Row>
          </DropdownItem>
          <DropdownItem on:click={selectToken(USDC)}>
            <Row class="gx-1">
              <Col class="col-auto">
                <img class="icon-small" src="/icons/currency-usdc.svg" alt="placeholder"/>
              </Col>
              <Col class="align-self-start">
                &nbsp;&nbsp;{USDC.symbol}
              </Col>
            </Row>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </Col>
    <Col>
      <Input class="token-input upload-price-input" placeholder="0.0" on:input={oninput}/>
    </Col>
  </Row>
</div>
